/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { BlastWmksSession } from "../../../common/blast-wmks.service";
import { CommonSvcService } from "../../commonSvc.service";

export namespace HTML5MMR {
   export class SessionModel {
      private wmksSession: BlastWmksSession;
      private commonSvcService: CommonSvcService;
      private defaultDPI: number;

      constructor(wmksSession: BlastWmksSession, commonSVCService: CommonSvcService, defaultDPI: number) {
         this.wmksSession = wmksSession;
         this.commonSvcService = commonSVCService;
         this.defaultDPI = defaultDPI;
      }

      /**
       * Retrieve wmks session key
       *
       * @returns string
       */
      public get key(): string {
         return this.wmksSession.key;
      }

      /**
       * Retrieve remote DPI for this wmks session
       *
       * @returns number
       */
      public get remoteDPI(): number {
         return this.commonSvcService.getRemoteDPI(this.key) || this.defaultDPI;
      }
   }
}
